import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

/**
 * Creates an image renderer function that intelligently chooses between
 * optimized Gatsby images and standard img tags.
 *
 * @param optimizedImageData - Gatsby image data to use if available
 * @param optimizedAlt - Alt text to use with optimized image
 * @param shouldUseOptimized - Optional function to determine if optimized image should be used for a given src
 * @returns A render function compatible with mlcomponents image rendering props
 */
export const createImageRenderer = ({
    optimizedImageData,
    optimizedAlt,
    shouldUseOptimized,
}: {
    optimizedImageData: IGatsbyImageData | null;
    optimizedAlt?: string;
    shouldUseOptimized?: (src: string) => boolean;
}) => {
    return ({ src = '', alt = '', className = '' }: { src?: string; alt?: string; className?: string }) => {
        const useOptimized = shouldUseOptimized ? shouldUseOptimized(src) : !!optimizedImageData;

        if (optimizedImageData && useOptimized) {
            return <GatsbyImage image={optimizedImageData} alt={optimizedAlt || alt} className={className} />;
        }

        return <img src={src} alt={alt} className={className} loading="lazy" decoding="async" />;
    };
};
